import React from 'react';

import BaseSvg, { BaseSvgProps } from '../../BaseSvg';

const ThunderSvg: React.FunctionComponent<BaseSvgProps> = ({ className = '', fillColor, secondaryFillColor }) => {
    return (
        <BaseSvg className={className} viewBox="0 0 18.06 16.86">
            <path
                fill={fillColor}
                d="M17.05,6.61v.63L17,7.56a2.9,2.9,0,0,1-3.27,2.25c-.29,0-.57-.15-.87-.22a2.82,2.82,0,0,1-4.39.6h0l-.07.07a3.54,3.54,0,0,1-1.62.9c-.26.06-.52.09-.78.14h-.3l-.09,0A3.66,3.66,0,0,1,2.9,9.89a.21.21,0,0,0-.16-.06A2.24,2.24,0,0,1,.29,8.27c0-.12-.07-.24-.1-.36s0-.38,0-.57a.34.34,0,0,0,0-.07A2.2,2.2,0,0,1,1.94,5.44l.5-.08A2.83,2.83,0,0,1,6.21,3.1a4.42,4.42,0,0,1,8.62,1l.11,0a2.88,2.88,0,0,1,2,2.08C17,6.35,17,6.48,17.05,6.61Z"
            />
            <polygon fill={fillColor} points="1.52 11.25 0 15.98 2.65 12.14 1.52 11.25" />
            <polygon fill={fillColor} points="5.45 12.62 5.04 16.86 7.16 12.62 5.45 12.62" />
            <polygon fill={fillColor} points="10.79 12.43 11.67 16.65 12.1 12.14 10.79 12.43" />
            <polygon fill={fillColor} points="14.58 11.44 18.06 16.86 15.82 10.91 14.58 11.44" />
        </BaseSvg>
    );
};

export default ThunderSvg;
